export default {
    NAO_AGUDA: 1,
    BAIXA: 2,
    INTERMEDIARIA: 3,
    ALTA: 4,
}